import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { config } from "config";
import { IPricingEngineState } from ".";

const default_page_size = config.PAGE_SIZE;

const initialState: IPricingEngineState = {
    pricingEngines: [],
    pricingEngine: null,
    loading: true,
    refresh: 0,
    refreshLoader: false,
    current_filters: {},
    filters: { page: 1, page_size: default_page_size },
    count: 0,
    priceEngineOptions: []
};

export const pricingEngineSlice = createSlice({
    name: "pricingEngine",
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        refresh: (state) => {
            state.refresh += 1;
            state.refreshLoader = true;
        },
        resetPage: (state) => {
            state.filters.page = 1;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
            state.refreshLoader = true;
        },
        setCurrentFilters: (state, action) => {
            state.current_filters = action.payload;
        },
        resetFilters: (state) => {
            state.refresh += 1;
            state.refreshLoader = true;
            state.filters = initialState.filters;
            state.current_filters = initialState.current_filters;
        },
        addPricingEngine: (state, action) => {
            state.pricingEngines.unshift(action.payload);
        },
        updatePricingEngine: (state, action) => {
            const { id, pricingEngine } = action.payload;
            state.pricingEngines.every(({ _id }, i) => {
                if (id === _id) {
                    state.pricingEngines[i] = pricingEngine;
                    return false;
                }
                return true;
            });
        },
        setPricingEngine: (state, action) => {
            state.pricingEngine = action.payload;
        },
        setPricingEngines: (state, action) => {
            const { priceEngines, count } = action.payload;
            state.pricingEngines = priceEngines;
            state.priceEngineOptions = priceEngines.map(({ _id, name }: any) => ({
                label: name,
                value: _id
            }));
            state.count = count;
            state.refreshLoader = false;
        }
    }
});

export const pricingEngineActions = pricingEngineSlice.actions;
export default pricingEngineSlice.reducer; 